/* eslint-disable prefer-object-spread */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import InventoryService from '../../../../services/InventoryService';
import ListPagination from '../../../../components/UI/ListPaginationUl';
import { ENUMS } from '../../../../utils/constants';
import ConfirmModalQuantity from './ConfirmModalQuantity';

const ListLotItemClosed = (props) => {
    const [lotItems, setLotItems] = useState([]);
    const [reading, setReading] = useState({});
    const [lastReadingQuantity, setLastReadingQuantity] = useState({});
    const [currentPage, setCurrentPage] = useState(0);
    const [openModalConfirm, setOpenModalConfirm] = useState(false);


    useEffect(() => {
        refresh();
        // eslint-disable-next-line
    }, [props?.lotItems?.items]);


    const refresh = () => {
        if (props.lotItems?.items?.length > 0) {
            if (lotItems.length > 0 && currentPage === 0) {
                setLotItems(props.lotItems.items);
            } else {
                setLotItems((prevState) => ([...prevState, ...props.lotItems.items]));
            }
            var lotItem = props.lotItems?.items.find((f) => f.lotItemNumber === parseInt(props.filter.lotItemNumber)
                || f.validationCode === props.filter.validationCode);
            if (lotItem && lotItem.readings && lotItem.readings.length > 0) {
                var lastReading = lotItem.readings?.find(i => i.versionQuantity === lotItem.readings?.length)?.quantity;
                setLastReadingQuantity(lastReading);
            }
        } else {
            setLotItems([]);
        }
    };

    useEffect(() => {
        const filter = Object.assign({}, props.filter);
        props.getLotItems(props.user.vision, filter, {
            PageSize: 20,
            PageIndex: currentPage
        });
        // eslint-disable-next-line
    }, [currentPage]);


    const onRenderItem = (data) => {
        return (
            <>
                {
                    data.status === ENUMS.eInventoryLotItemStatus.Finished.value ?
                        <span
                            className="title sixth-text-color right"
                            style={{ position: 'absolute', marginTop: '0px', right: '10px', zIndex: '999' }}
                        ><i onClick={(event) => {
                            event.preventDefault();
                            setOpenModalConfirm(true);
                            setReading(data);
                        }}
                            className={`mdi mdi-36px mdi-pencil green-text`} />
                        </span> : null
                }
                <span className="title sixth-text-color">
                    <i className="mdi mdi-text-box-check-outline" /> {data.lotItemNumber}
                </span>
                <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>
                    <i className="mdi mdi-map-marker-radius-outline" /> {data.location}
                </span>
                <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>
                    <i className="mdi mdi-image-filter-center-focus" /> {data.cim}
                </span>
            </>
        );
    };

    return lotItems ? (
        <div>
            <div id="listLotItems">
                <ListPagination
                    page={props.lotItems?.totalPages}
                    current={{ currentPage, setCurrentPage }}
                    data={
                        lotItems.filter((f) => f.lotItemNumber === parseInt(props.filter.lotItemNumber)
                            || f.validationCode === props.filter.validationCode
                        ).map((item) => {
                            return onRenderItem(item);
                        })
                    }
                />
            </div>
            <ConfirmModalQuantity
                open={openModalConfirm}
                id="ConfirmModalQuantity"
                content="Alterar Quantidade"
                dismissible={false}
                onCancel={() => { setOpenModalConfirm(false); setReading({}) }}
                onClose={() => { setOpenModalConfirm(false); setReading({}) }}
                onConfirm={(evt) => {
                    props.readingItemClosed(reading, evt.quantity, evt.qrCode, props.user.vision, () => {
                        setReading({});
                        props.history.go(-1);
                    });
                }}
                lastReadingQuantity={lastReadingQuantity}
            />
        </div>
    ) : null;
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        filter: state.inventoryReducer.filter,
        lotItems: state.inventoryReducer.lotItems,
        lots: state.inventoryReducer.lots,
        lotItem: state.inventoryReducer.lotItem
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getLotItems: (vision, filter, pagination) => {
            dispatch(InventoryService.getLotItems(vision, filter, pagination));
        },
        readingItemClosed: (reading, quantity, qrCode, vision, callback) => {
            dispatch(InventoryService.readingLotItemClosed(reading, quantity, qrCode, vision, callback));
        },
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ListLotItemClosed));
